export enum TipoAtendimentoEnum {
  LOJA = "LOJA",
  DOMICILIO = "DOMICILIO",
  ITINERANTE = "ITINERANTE",
}
